import AmplitudeUtils from '../utils/amplitude-utils';
import { getBannerTypeForSessionExpiry } from '../utils/banner-jwt-utils';
import { getLocalizedString } from '../utils/i18n-utils';
import { setStateTokenExpiryBannerType } from '../utils/storage-utils';
import { startSpinnerAndHideForm } from '../utils/widget-facade';
import BaseForgeCustomizer from './base-forge';
import { launchLwa } from '../utils/lwa-utils';

export default class TerminalCustomizer extends BaseForgeCustomizer {
  hideOktaFooter = true;
  renderTerminalView = true;
  async shouldCustomize() {
    return this.context.formName === 'terminal';
  }
  async customize() {
    const errorMessage = jQueryCourage('.o-form-error-container').text()
      .trim();
    if (errorMessage === getLocalizedString('idx.session.expired')) {
      this.renderTerminalView = false;
    }
    await super.customize();
    if (errorMessage === getLocalizedString('idx.session.expired')) {
      startSpinnerAndHideForm();
      AmplitudeUtils.logCustomEvent('StateTokenExpired', {});
      await this.navigateToPrimaryAuthAndRenderSessionTimeoutBanner();
    }
  }

  async navigateToPrimaryAuthAndRenderSessionTimeoutBanner() {
    if (settings.isAuthnWithLwaClientId) {
      await launchLwa({});
    }
    else {
      const searchParams = new URLSearchParams(window.location.search);
      const bannerType = await getBannerTypeForSessionExpiry();
      setStateTokenExpiryBannerType(bannerType);
      window.location.search = searchParams.toString();
    }
  }
}
